import { SxProps } from '@mui/system';
import { styled, Theme } from '@mui/material';

interface CerebroStyledBox extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	sx?: SxProps<Theme>;
	error?: boolean;
	alignitems?: BoxAlignItems;
}
type BoxAlignItems = 'left' | 'center' | 'right';

export const CerebroStyledBox: React.FC<CerebroStyledBox> = ({ alignitems, children, ...props }) => {
	return (
		<StyledWrapper alignitems={alignitems} {...props}>
			{children}
		</StyledWrapper>
	);
};

interface WrapperProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	error?: boolean;
	alignitems?: BoxAlignItems;
}

const Wrapper: React.FC<WrapperProps> = props => <div {...props} />;

const StyledWrapper = styled(Wrapper, { shouldForwardProp: prop => prop !== 'sx' && prop != 'error' })(
	({ error, theme, alignitems }) => ({
		backgroundColor: theme.palette.common.white,
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: error ? theme.palette.error.main : theme.palette.gray.medium,
		borderRadius: theme.shape.borderRadius,
		boxShadow: error ? theme.solidShadow(theme.palette.error.main, 3) : theme.shadows[3],
		alignItems: alignitems ? alignitems : 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		padding: theme.spacing(3),
		paddingTop: theme.spacing(4.5),
	})
);
